import React from "react";
import { Flexbox, Image, Loader, Text, ThemeSwitch } from "@profiler/ui";
import logo from "@profiler/ui/image/logo.png";

import { useLoader, useTheme } from "../hooks";
import { HEADER_HEIGHT } from "../constants";

export const Header = () => {
  const { isLoading } = useLoader();
  const { mode, setMode: setThemeMode } = useTheme();

  return (
    <Flexbox
      height={HEADER_HEIGHT}
      flexFlow="row nowrap"
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="contrast"
      py={2}
      px={3}
    >
      <Flexbox
        flexFlow="row nowrap"
        justifyContent="center"
        alignItems="center"
      >
        <Image src={logo} alt="Logo" width="30px" />
        <Text fontSize={4} color="text" ml={2}>
          Kodjin FHIRPath Helper
        </Text>
      </Flexbox>

      <Flexbox
        flexFlow="row nowrap"
        justifyContent="center"
        alignItems="center"
      >
        <ThemeSwitch mode={mode} onChange={setThemeMode} />
        <Loader visibility={isLoading ? "visible" : "hidden"} />
      </Flexbox>
    </Flexbox>
  );
};
